import * as React from 'react';
import * as style from './styles.css';

export const StepsSmall = () => {
  return (
    <div className={style['steps-container']}>
      <div className={style['step']}>
        <div className={style['step-content']}>
          <div className={style['step-count']}>1</div>
          <p className={style['step-description']}>
            Вы заполняете анкету. Никаких сканов и справок — нужен паспорт и название работодателя
          </p>
        </div>
      </div>
      <div className={style['step']}>
        <div className={style['step-content']}>
          <div className={style['step-count']}>2</div>
          <p className={style['step-description']}>
            Банки пришлют предложения через 2 минуты. Это не «рекламные» ставки, а&nbsp;реальные условия кредита для вас
          </p>
        </div>
      </div>
      <div className={style['step']}>
        <div className={style['step-content']}>
          <div className={style['step-count']}>3</div>
          <p className={style['step-description']}>
            Выберите лучшее предложение. Только после этого банк свяжется с вами. Никаких других звонков
          </p>
        </div>
      </div>
    </div>
  );
};
